import React from 'react';

import Button from '@components/uikit/Button/Button';

import useTranslation from '@hooks/useTranslation';

import { useModalActions } from '@store/useModalStore';

import ModalHeader from '../ModalHeader/ModalHeader';
import style from './style.module.scss';

const ModalConfirm = ({
  title,
  bodyTitle,
  text,
  bodyContent,
  confirmText,
  cancelText,
  onCancel,
  onConfirm,
  type = 'main',
}) => {
  const { t } = useTranslation();
  const { setModalClose, setSecondaryModalClose } = useModalActions();

  const handleClose = () => {
    if (onCancel) {
      onCancel();
    }

    closeFunc();
  };

  const handleConfirm = () => {
    onConfirm();
    closeFunc();
  };

  const closeFunc = () => {
    if (type === 'secondary') {
      setSecondaryModalClose();
    } else {
      setModalClose();
    }
  };

  return (
    <div className={style.confirmModal}>
      <ModalHeader title={title || ''} onClose={closeFunc} />
      <div className={style.modalBody}>
        <div className={style.modalBodyTitle}>{bodyTitle}</div>
        <div className={style.modalBodyConfirmText}>
          {bodyContent || <h4 className={style.textCenter}>{text}</h4>}
        </div>
      </div>
      <div className={style.modalFooter}>
        <Button type="primary" text={confirmText || t('Yes')} onClick={handleConfirm} />
        <Button type="secondary" text={cancelText || t('Cancel')} onClick={handleClose} />
      </div>
    </div>
  );
};

export default ModalConfirm;
